<section class="fuel-calculator" aria-labelledby="fuel-calculator-title">
    <header>
        <div class="fuel-calculator__eyebrow">Фактический расход</div>
        <h2 id="fuel-calculator-title">Калькулятор расхода топлива на 100 км</h2>
        <p>Введите пробег между заправками и объём израсходованного топлива.</p>
    </header>

    <div class="fuel-calculator__body">
        <form class="fuel-calculator__fields">
            <label>
                <span>Пройдено</span>
                <div><input type="number" inputmode="decimal" min="1" [(ngModel)]="distance" name="fuel_distance"
                            (ngModelChange)="onValueChange()"><b>км</b></div>
            </label>
            <label>
                <span>Израсходовано</span>
                <div><input type="number" inputmode="decimal" min="0.1" step="0.1" [(ngModel)]="litres"
                            name="fuel_litres" (ngModelChange)="onValueChange()"><b>л</b></div>
            </label>
            <label>
                <span>Цена топлива</span>
                <div><input type="number" inputmode="decimal" min="1" step="0.01" [(ngModel)]="price"
                            name="fuel_price_actual" (ngModelChange)="onValueChange()"><b>₽/л</b></div>
            </label>
        </form>

        <aside class="fuel-calculator__result" aria-live="polite">
            <span>Средний расход</span>
            <strong>{{ format(consumption(), 2) }} л/100 км</strong>
            <div>
                <p><span>Стоимость топлива</span><b>{{ format(totalCost(), 2) }} ₽</b></p>
                <p><span>Цена 100 км</span><b>{{ format(costPer100Km(), 2) }} ₽</b></p>
            </div>
        </aside>
    </div>
    <p class="fuel-calculator__note">Для точности считайте от полного бака до полного бака и используйте фактический
        объём следующей заправки.</p>
</section>

